import { contentApi } from '@/infrastructure/Configuration'
export default class TripAdvisorService {
  constructor (httpClient) {
    this.httpClient = httpClient
  }

  async getTripAdvisorRating (hotelCodes) {
    const url = `${contentApi}/multiple-hotels-ratings`

    const params = {
      hotelCodes: hotelCodes.join(',')
    }

    let response
    try {
      response = await this.httpClient.get(url, { params })
    } catch (error) {
      console.error(error)
    }
    return response?.data?.hotels || []
  }

  async getTripAdvisorSingleHotelRating (hotelCode) {
    const url = `${contentApi}/hotels/${hotelCode}/rating`
    const response = await this.httpClient.get(url)

    return response.data
  }
}
